module.exports = __webpack_public_path__ + "static/media/back_02.f85236bb.svg";